import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { CreatePartner } from "../../services/Partners";

// Esquema de validación con Yup
const validationSchema = Yup.object({
  businessName: Yup.string()
    .required("El nombre o razón social es requerido")
    .min(2, "Debe tener al menos 2 caracteres"),
  rfc: Yup.string()
    .required("El RFC es requerido")
    .matches(
      /^([A-ZÑ&]{3,4})?(?:\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))?[A-Z\d]{2}[\dA]$/,
      "Formato de RFC inválido"
    ),
  email: Yup.string()
    .required("El correo electrónico es requerido")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Formato de correo electrónico inválido"
    ),
  phone: Yup.string()
    .required("El teléfono es requerido")
    .min(10, "El teléfono debe tener al menos 10 dígitos"),
  address: Yup.string()
    .required("La dirección es requerida")
    .min(5, "La dirección debe tener al menos 5 caracteres"),
  contactName: Yup.string()
    .required("El nombre de contacto es requerido")
    .min(2, "Debe tener al menos 2 caracteres"),
  contactEmail: Yup.string()
    .required("El correo de contacto es requerido")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Formato de correo electrónico inválido"
    ),
  contactPhone: Yup.string()
    .required("El teléfono de contacto es requerido")
    .min(10, "El teléfono debe tener al menos 10 dígitos"),
});

export const PartnersSignUpForm = (props) => {
  const [error, showError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const { data } = await CreatePartner(values);
      if (data) {
        setSuccessMessage(
          "Su registro ha sido exitoso. Nos pondremos en contacto con usted cuando la información haya sido validada."
        );
      } else {
        showError("Ha ocurrido un error.");
      }
      // Limpiar el formulario después del envío exitoso
      resetForm();
    } catch (error) {
      showError("Ha ocurrido un error.");
      setSuccessMessage(""); // Limpiar mensaje de éxito si hay error
    } finally {
      setSubmitting(false);
    }
  };

  const initialValues = {
    businessName: "",
    rfc: "",
    email: "",
    phone: "",
    address: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
  };

  return (
    <div>
      <div className="has-text-centered">
        <img src="/assets/logo.png" alt="Invix" className="logo is-centered" />
      </div>
      <br />
      <p className="title is-3 has-text-centered">Registro de Partner</p>
      <p className="subtitle is-6 has-text-justified ">
        Complete el siguiente formulario para registrarse como partner. nosotros
        le notificaremos cuando su información haya sido validada.
      </p>
      {error !== "" ? (
        <div>
          <div className="notification is-danger has-text-white">{error}</div>
          <br />
        </div>
      ) : null}
      {successMessage !== "" ? (
        <div>
          <div className="notification is-info has-text-white">
            {successMessage}
          </div>
          <br />
        </div>
      ) : null}

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting,
          setFieldValue,
        }) => (
          <Form>
            <div className="columns">
              <div className="column">
                {/* Nombre o Razón Social */}
                <div className="field">
                  <label className="label">Nombre o Razón Social</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.businessName && touched.businessName
                          ? "is-danger"
                          : ""
                      }`}
                      type="text"
                      placeholder="Ingrese el nombre o razón social"
                      value={values.businessName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="businessName"
                    />
                  </div>
                  {errors.businessName && touched.businessName && (
                    <p className="help is-danger">
                      {errors.businessName ?? ""}
                    </p>
                  )}
                </div>

                {/* Correo electrónico */}
                <div className="field">
                  <label className="label">Correo electrónico</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.email && touched.email ? "is-danger" : ""
                      }`}
                      type="email"
                      placeholder="Ingrese el correo electrónico"
                      value={values.email}
                      onChange={(e) => {
                        handleChange(e);
                        // Sincronizar correo de contacto con correo principal
                        if (
                          !values.contactEmail ||
                          values.contactEmail === values.email
                        ) {
                          setFieldValue("contactEmail", e.target.value);
                        }
                      }}
                      onBlur={handleBlur}
                      name="email"
                    />
                  </div>
                  {errors.email && touched.email && (
                    <p className="help is-danger">{errors.email ?? ""}</p>
                  )}
                </div>

                {/* Dirección */}
                <div className="field">
                  <label className="label">Dirección</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.address && touched.address ? "is-danger" : ""
                      }`}
                      type="text"
                      placeholder="Ingrese la dirección"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="address"
                    />
                  </div>
                  {errors.address && touched.address && (
                    <p className="help is-danger">{errors.address ?? ""}</p>
                  )}
                </div>

                {/* Correo de Contacto */}
                <div className="field">
                  <label className="label">Correo de Contacto</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.contactEmail && touched.contactEmail
                          ? "is-danger"
                          : ""
                      }`}
                      type="email"
                      placeholder="Ingrese el correo de contacto"
                      value={values.contactEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="contactEmail"
                    />
                  </div>
                  {errors.contactEmail && touched.contactEmail && (
                    <p className="help is-danger">
                      {errors.contactEmail ?? ""}
                    </p>
                  )}
                </div>
              </div>

              <div className="column">
                {/* RFC */}
                <div className="field">
                  <label className="label">RFC</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.rfc && touched.rfc ? "is-danger" : ""
                      }`}
                      type="text"
                      placeholder="RFC"
                      value={values.rfc}
                      onChange={(e) => {
                        handleChange(e);
                        // Sincronizar correo de contacto con correo principal
                        if (e.target.name === "email" && !values.contactEmail) {
                          setFieldValue("contactEmail", e.target.value);
                        }
                      }}
                      onBlur={handleBlur}
                      name="rfc"
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                  {errors.rfc && touched.rfc && (
                    <p className="help is-danger">{errors.rfc ?? ""}</p>
                  )}
                </div>

                {/* Teléfono */}
                <div className="field">
                  <label className="label">Teléfono</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.phone && touched.phone ? "is-danger" : ""
                      }`}
                      type="tel"
                      placeholder="Ingrese el teléfono"
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="phone"
                    />
                  </div>
                  {errors.phone && touched.phone && (
                    <p className="help is-danger">{errors.phone ?? ""}</p>
                  )}
                </div>

                {/* Nombre de Contacto */}
                <div className="field">
                  <label className="label">Nombre de Contacto</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.contactName && touched.contactName
                          ? "is-danger"
                          : ""
                      }`}
                      type="text"
                      placeholder="Ingrese el nombre de contacto"
                      value={values.contactName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="contactName"
                    />
                  </div>
                  {errors.contactName && touched.contactName && (
                    <p className="help is-danger">{errors.contactName ?? ""}</p>
                  )}
                </div>

                {/* Teléfono de Contacto */}
                <div className="field">
                  <label className="label">Teléfono de Contacto</label>
                  <div className="control">
                    <input
                      className={`input is-medium ${
                        errors.contactPhone && touched.contactPhone
                          ? "is-danger"
                          : ""
                      }`}
                      type="tel"
                      placeholder="Ingrese el teléfono de contacto"
                      value={values.contactPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="contactPhone"
                    />
                  </div>
                  {errors.contactPhone && touched.contactPhone && (
                    <p className="help is-danger">
                      {errors.contactPhone ?? ""}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <button
              className="button is-primary is-fullwidth"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Creando cuenta..." : "Crear cuenta"}
            </button>

            <a
              href="/partners"
              className="button is-light is-fullwidth"
              style={{ marginTop: "10px" }}
            >
              Iniciar sesión
            </a>
          </Form>
        )}
      </Formik>
      <br />
    </div>
  );
};
